module.exports = __webpack_public_path__ + "static/zaibatsu-aaa3de4a8d2d5048e61ebbcb9bb57850.svg";